import { serviceBundleApiKeyStore } from '../../../../api/service-bundle-api-key-store';
import { LoadingIndicator } from '../../../../components/loading-indicator.component';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { ServiceBundle } from '../../../../models/service-bundle';
import { SaveServiceBundleForm } from './save-service-bundle.form';

interface CreateServiceBundleFormProps {
  projectID: number;
  serviceBundleID: number;
  onCompleted: (value: ServiceBundle) => void;
  refetch: () => void;
}

export const EditServiceBundleForm = ({
  serviceBundleID,
  projectID,
  onCompleted,
  refetch,
}: CreateServiceBundleFormProps) => {
  const { data, isLoading } = useLoadData<ApiResponse<ServiceBundle>>(
    serviceBundleApiKeyStore.getServiceBundleDetails(serviceBundleID)
  );

  return (
    <>
      <LoadingIndicator isLoading={isLoading} />
      {data?.data && (
        <SaveServiceBundleForm
          projectID={projectID}
          serviceBundle={data?.data}
          onCompleted={onCompleted}
          refetch={refetch}
        />
      )}
    </>
  );
};
